import { loadScript } from './loadscript';
import { AuthService } from '../services/auth.service';
import { LicenseService } from '../services/license.service';

declare global {
    interface Window {
        CRISP_WEBSITE_ID: any;
        $crisp: any[];
    }
}

export function crispLoader(licenseService: LicenseService, authService: AuthService) {
    const user = authService.getUser();

    if (user && user._role === 'ADMIN') {
        return;
    }

    licenseService.getCrispKey().subscribe(async res => {
        let crispKey = res?.data?.get_crisp_key?.key;

        // [DEV] Force Test Key if missing
        if (!crispKey) {
            crispKey = '1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d'; // Fallback key
        }

        if (!crispKey && (!res || !res.data || !res.data.get_crisp_key || res.errors)) {
            return;
        }

        const client = authService.getClient();

        if (!client || !client.uniq) {
            return;
        }

        const licenseType: any[] = [];

        licenseService.getClientLicenseSites(client.uniq, 'CLIENT').subscribe(response => {
            if (response && response.data && response.data.client && response.data.client.sites) {
                response.data.client.sites.forEach((site: any) => {
                    if (site && site.license && site.license.type) {
                        licenseType.push(site.license.type);
                    }
                });
            }
        });

        const saas = client.sass ? 'sans engagement' : 'avec engagement';
        window.CRISP_WEBSITE_ID = crispKey;

        loadScript('https://client.crisp.chat/l.js', 'ze-snippet')
            .then(() => {
                // Initialize $crisp array if it doesn't exist yet (though the script ideally creates it)
                if (!window.$crisp) {
                    window.$crisp = [];
                }

                setTimeout(() => {
                    if (window.$crisp) {
                        window.$crisp.push(["set", "user:nickname", client.manager]);
                        window.$crisp.push(["set", "user:email", client.email]);
                        window.$crisp.push(["set", "user:phone", client.phone]);
                        window.$crisp.push(["set", "user:company", client.company]);

                        window.$crisp.push(["set", "session:segments", [["admin", saas, client.country_code], true]]);

                        licenseType.forEach(licenceName => {
                            window.$crisp.push(["set", "session:segments", [[licenceName]]]);
                        });
                    }
                }, 2000);
            })
            .catch(e => {
                console.error('Crisp Chat failed to load', e);
            });
    });
}
